import Vue from 'vue'
import VueCookies from 'vue-cookies'
// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: 'https://b.m91.link',
  // timeout: 1000,
})
// Set the AUTH token for any request
axiosIns.interceptors.request.use(config => {
  ///if()
  console.log(config.url.includes('google/data/?access_token='))
  //
  // eslint-disable-next-line no-param-reassign
  if(!config.url.includes('google/data/?access_token=') && !config.url.includes('validator'))
  {
  config.headers.token = VueCookies.get('token')
  }
  return config
})

Vue.prototype.$http = axiosIns

export default axiosIns
